<template>
  <div class="flex flex-col lg:flex-row border-b border-gray-200 dark:border-dark-5 pb-5 -mx-5">
    <div class="flex flex-1 px-5 items-center justify-center lg:justify-start">
      <div class="w-20 h-20 sm:w-24 sm:h-24 flex-none image-fit relative">
        <div
          class="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-gray-200 dark:bg-dark-5 rounded-full"
        >
          <UserIcon />
        </div>
      </div>
      <div class="ml-5">
        <div class="w-24 sm:w-40 truncate sm:whitespace-normal font-medium text-lg">
          {{ officer | fullName }}
        </div>
        <div class="text-gray-600">
          {{ $t(`roles.${$options.filters.stringCamelize(officer.role)}`) }}
        </div>
        <div class="text-gray-600">
          {{ officer.phone }}
        </div>
      </div>
    </div>
    <div
      class="flex mt-6 lg:mt-0 items-center lg:items-start flex-1 flex-col justify-center text-gray-600 dark:text-gray-300 px-5 border-l border-r border-gray-200 dark:border-dark-5 border-t lg:border-t-0 pt-5 lg:pt-0"
    >
      <div
        v-if="officer.loanTotalAmount"
        class="truncate sm:whitespace-normal flex items-center my-1"
      >
        <p class="mr-2">{{ $t('text.loanPackage') }}:</p>
        {{ officer.loanTotalAmount | currency }}
      </div>
      <div v-if="officer.loanCount" class="truncate sm:whitespace-normal flex items-center my-1">
        <p class="mr-2">{{ $t('text.customer') }}:</p>
        {{ officer.loanCount }}
      </div>
      <div
        v-if="typeof officer.overdueLoansCount === 'number'"
        class="truncate sm:whitespace-normal flex items-center my-1"
      >
        <p class="mr-2">{{ $t('text.loanOverdue') }}:</p>
        {{ officer.overdueLoansCount }}
      </div>
    </div>
    <div
      class="mt-6 lg:mt-0 flex-1 flex items-center justify-center px-5 border-t lg:border-0 border-gray-200 dark:border-dark-5 pt-5 lg:pt-0"
    >
      <div class="text-center rounded-md py-3 mr-4">
        <div class="font-semibold text-theme-1 dark:text-theme-10 text-lg">
          -
        </div>
        <div class="text-gray-600">{{ $t('text.haveDeadline') }}</div>
      </div>
      <div class="text-center rounded-md py-3">
        <div class="font-semibold text-theme-1 dark:text-theme-10 text-lg">
          -
        </div>
        <div class="text-gray-600">{{ $t('text.worked') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    officer: Object,
  },
};
</script>
